import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KNewsWidgetTextBackgroundType, KNewsWidgetVerticalTextAlignType, KNewsWidgetChipStyle } from './index.props.js';

var PREFIX = "KNewsColumnWidget";
var classesNewsImage = {
    header: "".concat(PREFIX, "-header"),
    chipContainer: "".concat(PREFIX, "-chipContainer"),
    chip: "".concat(PREFIX, "-chip")
};
var StyledKNewsImageWidget = styled(Box, {
    shouldForwardProp: function (prop) {
        return prop !== "backgroundTextEffect" &&
            prop !== "backgroundTextColor" &&
            prop !== "verticalTextAlign" &&
            prop !== "borderRadius" &&
            prop !== "borderColor" &&
            prop !== "image" &&
            prop !== "marginTop" &&
            prop !== "marginBottom" &&
            prop !== "chip";
    }
})(function (_a) {
    var _b;
    var _c;
    var theme = _a.theme, backgroundTextEffect = _a.backgroundTextEffect, backgroundTextColor = _a.backgroundTextColor, verticalTextAlign = _a.verticalTextAlign, borderRadius = _a.borderRadius, borderColor = _a.borderColor, image = _a.image, marginTop = _a.marginTop, marginBottom = _a.marginBottom, chip = _a.chip;
    return (__assign(__assign({}, (borderColor && { border: "1px solid ".concat(borderColor) })), (_b = { borderRadius: borderRadius, alignSelf: "stretch", backgroundImage: "url(".concat(image === null || image === void 0 ? void 0 : image.url, ")"), backgroundSize: "cover", backgroundPosition: "center", cursor: "pointer", width: "100%", marginTop: marginTop || "unset", marginBottom: marginBottom || "unset", minHeight: (image === null || image === void 0 ? void 0 : image.minHeight) || "unset" }, _b["& .".concat(classesNewsImage.header)] = {
        position: "absolute",
        width: "100%",
        borderRadius: backgroundTextEffect === KNewsWidgetTextBackgroundType.TopEffect
            ? "".concat(borderRadius, " ").concat(borderRadius, " 0 0")
            : "0 0 ".concat(borderRadius, " ").concat(borderRadius),
        padding: theme.spacing(3),
        top: verticalTextAlign === KNewsWidgetVerticalTextAlignType.Top
            ? "0"
            : verticalTextAlign === KNewsWidgetVerticalTextAlignType.Center
                ? "50%"
                : "auto",
        bottom: verticalTextAlign === KNewsWidgetVerticalTextAlignType.Bottom ? "0" : "auto",
        transform: verticalTextAlign === KNewsWidgetVerticalTextAlignType.Center
            ? "translate(0%, -50%)"
            : "none",
        background: backgroundTextEffect === KNewsWidgetTextBackgroundType.NoBackground
            ? "transparent"
            : backgroundTextEffect === KNewsWidgetTextBackgroundType.BottomEffect
                ? "linear-gradient(rgba(0, 0, 0, 0) 0%, ".concat(backgroundTextColor, " 100%)")
                : backgroundTextEffect === KNewsWidgetTextBackgroundType.TopEffect
                    ? "linear-gradient(".concat(backgroundTextColor, " 0%, rgba(0, 0, 0, 0) 100%)")
                    : backgroundTextColor,
        marginTop: marginTop || "unset",
        marginBottom: marginBottom || "unset"
    }, _b["& .".concat(classesNewsImage.chipContainer)] = {
        display: "flex"
    }, _b["& .".concat(classesNewsImage.chip)] = {
        borderRadius: (_c = chip === null || chip === void 0 ? void 0 : chip.borderRadius) !== null && _c !== void 0 ? _c : theme.shape.borderRadius,
        backgroundColor: (chip === null || chip === void 0 ? void 0 : chip.style) === KNewsWidgetChipStyle.Filled ? chip === null || chip === void 0 ? void 0 : chip.color : chip === null || chip === void 0 ? void 0 : chip.backgroundColorOutlined,
        borderColor: chip === null || chip === void 0 ? void 0 : chip.color,
        color: chip === null || chip === void 0 ? void 0 : chip.labelColor,
        cursor: "pointer"
    }, _b)));
});

export { classesNewsImage, StyledKNewsImageWidget as default };
//# sourceMappingURL=index.image.styled.js.map
